<template>
  <vue-custom-scrollbar
    class="scroll-area"
    v-scrollbar="{ isbuttom }"
    :settings="settings"
    @ps-scroll-y="scrollHanle"
    @ps-y-reach-end="scrollButtom"
  >
    <slot></slot>
  </vue-custom-scrollbar>
</template>
<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  name: 'Scroller',
  props: ['isbuttom'],
  components: {
    vueCustomScrollbar,
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        suppressScrollX: true,
        wheelPropagation: true,
      },
      scrolled: false,
    };
  },
  directives: {
    scrollbar: {
      bind(el, binding, vnode) {
        /*  if (vnode.target.scrollTop == 0) {
          this.$emit('on-scroll-top');
        } */
        /*  console.log(binding.value.isbuttom);
        if (binding.value.isbuttom == true) {
          el.scrollTop = 99999999;
        } */
      },
    },
  },
  methods: {
    scrollHanle(evt) {
      this.$emit('on-scrolling', true);
      if (evt && evt.target.scrollTop == 0) {
        this.$emit('on-scroll-top');
      }
    },
    scrollButtom(evt) {
      this.$emit('on-scroll-bottom');
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    },
  },
  mounted() {
    this.scrollHanle();
    this.scrollButtom();
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ScrollbarMobile.vue